import React from 'react';
import { createPortal } from 'react-dom';
/** Portal components used to mount modals, tooltips etc */
export const Portal = ({ children }) => {
    const [mounted, setMounted] = React.useState(false);
    const portalRootRef = React.useRef(null);
    const domNodeRef = React.useRef(null);
    React.useEffect(() => {
        if (typeof document !== 'undefined') {
            portalRootRef.current = document.getElementById('portal');
            if (portalRootRef.current === null) {
                throw new Error('You have used a component that uses the Portal component. Please add <div id="portal"></div> to your app within the <body> element.');
            }
            domNodeRef.current = document.createElement('div');
            portalRootRef.current.appendChild(domNodeRef.current);
            setMounted(true);
        }
        return () => {
            if (portalRootRef.current && domNodeRef.current) {
                portalRootRef.current.removeChild(domNodeRef.current);
            }
        };
    }, []);
    if (domNodeRef.current === null || !mounted) {
        return null;
    }
    return createPortal(children, domNodeRef.current);
};
export default React.memo(Portal);
//# sourceMappingURL=Portal.js.map